/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, type ReactNode } from 'react';
import { useVoiceRoom } from '../hooks/useVoiceRoom';

type VoiceContextValue = ReturnType<typeof useVoiceRoom>;

const VoiceContext = createContext<VoiceContextValue | null>(null);

/**
 * App-level voice session. Mounting the engine here (above the router) is what
 * lets a call keep running while the user navigates the rest of the site — the
 * stage and the floating dock are just consumers of this one connection.
 */
export function VoiceProvider({ children }: { children: ReactNode }) {
  const room = useVoiceRoom();
  return <VoiceContext.Provider value={room}>{children}</VoiceContext.Provider>;
}

export function useVoice(): VoiceContextValue {
  const ctx = useContext(VoiceContext);
  if (!ctx) throw new Error('useVoice must be used within <VoiceProvider>');
  return ctx;
}
